<div>
  <div class="card-display-list" [ngClass]="{'has-active-card':active >= 0}">
    <!-- <div class="card-display-item" [ngClass]="{'active-card':active == $i}"> -->
    <div class="card-display-item">
      <div>

        <i [ngClass]="item.icon" [title]="item.card_label||'Card'" *ngIf="info.active_card === false"></i>
        <div class="card-display-item-title" *ngIf="info.active_card !== false">{{item.card_label||'card'| translation}}</div>

      </div>
    </div>

  </div>

</div>
